import { Header } from "pages/components/header";
import { AssignmentsRegistrySection } from "./components/assignments-registry-section";

export const AssignmentsRegistry = () => {
  return (
    <>
      <Header />
      <AssignmentsRegistrySection />
    </>
  );
};
